import React, {
    useState,
    useEffect,

} from "react"
import { Typography } from './ot'

const BaseCardView1_3 = ({
    value = "",
    titleLevel = 4,
    className = "",
    style = {},
}, ref) => {


    return (
        <Typography.Title level={titleLevel} className={className} style={style}>{value}</Typography.Title>
    )
}

export default BaseCardView1_3
